import { render, staticRenderFns } from "./ProjectMultiEdit.vue?vue&type=template&id=6761d65a&scoped=true&"
import script from "./ProjectMultiEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectMultiEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761d65a",
  null
  
)

export default component.exports